// // Harshada Bhavsar(4/7/2025)
// //Jobcontext page to see the job posted in view  posted job
// //context api

// import React, { createContext, useContext, useState } from "react";

// // 1. Create Context
// const JobContext = createContext();

// // 2. Create Provider
// export const JobProvider = ({ children }) => {
//   const [jobs, setJobs] = useState([]);

//   const addJob = (job) => {
//     setJobs((prevJobs) => [...prevJobs, job]);
//   };

//   return (
//     <JobContext.Provider value={{ jobs, addJob }}>
//       {children}
//     </JobContext.Provider>
//   );
// };

// // 3. Create Custom Hook
// export const useJobContext = () => useContext(JobContext);

import React, { createContext, useContext, useState } from "react";

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);

  const addJob = (job) => {
    setJobs((prev) => [...prev, job]);
  };

  return (
    <JobContext.Provider value={{ jobs, addJob }}>
      {children}
    </JobContext.Provider>
  );
};

export const useJobContext = () => useContext(JobContext);
